const AssignmentTypeEnum = Object.freeze({
    Assistant: 1,
    PendingAmendment: 2,
    VacantPosition: 3
});

export { AssignmentTypeEnum };